import { Autocomplete } from '@mui/material';
import { admin } from '~/components/Admin/AdminDialog/AdminDialog.style';
import { StyledTextField } from '../../InternetResourceFilter/InternetResourceFilter.style';
import { TGetEditInternetResourceFormAutoComplete } from '../../AdminComponent.type';

export const InternetEditDialogAutocomplete = ({
  id,
  values,
  customOptions,
  isFreesolo,
  handleEdit,
  errorProps,
}: TGetEditInternetResourceFormAutoComplete) => {
  return (
    <Autocomplete
      value={values[`${id}`]}
      id={id}
      size="small"
      multiple
      freeSolo={isFreesolo}
      limitTags={3}
      options={customOptions}
      renderInput={params => (
        <StyledTextField {...params} color="info" {...errorProps(id)} />
      )}
      fullWidth
      onChange={(_event, newValue) => handleEdit({ newValue, id })}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          if (!option) return;
          return (
            <admin.Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
              key={option}
              isDefault={false}
            />
          );
        })
      }
    />
  );
};
